

























































import {Component} from "vue-property-decorator";
import ReportDeliverySearch from "@/modules/reportdelivery/List/components/Search/index.vue";
import ReportDeliveryStatusLabel from "@/shared/components/ReportDeliveryStatusLabel/index.vue";
import {ReportDeliveryStore} from "@/modules/reportdelivery/store";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import moment from "moment"
import {LadingTargetType} from "@/enums/type/ladingtarget";
import {PAGE_SIZE_OPTIONS} from "@/shared/constant";
import {ReportDeliveryStatus} from "@/enums/status";
import FormUpdateReportDelivery from "@/modules/reportdelivery/Update/index.vue";
import {downloadFromUrl} from "@/shared/services/helper/utils";
import TooltipLabel from "@/shared/components/TooltipLabel/TooltipLabel.vue";
import {ComplaintStore} from "@/modules/complaint/store";
import {ComplaintParams} from "@/modules/complaint/params";
import {ReportDeliveryParams} from "@/modules/reportdelivery/params";

@Component({
    name: "ListReportDelivery",
    components: {TooltipLabel, FormUpdateReportDelivery, ReportDeliveryStatusLabel, ReportDeliverySearch}
})
export default class extends mixins(CommonMixin) {
    moment = moment;
    LadingTargetType = LadingTargetType;
    columns = [

        {
            title: "STT",
            dataIndex: "stt",
            key: "stt",
            width: 50
        },
        {
            title: "Thao tác",
            dataIndex: "id",
            key: "id",
            width: 100,
            scopedSlots: { customRender: "action" },
            ellipsis: true
        },
        {
            title: "Ngày xác nhận",
            dataIndex: "billLading.createdDate",
            key: "ladingCreatedDate",
            width: 150,
            ellipsis: true
        },
        {
            title: "Mã khách hàng",
            dataIndex: "billLading.customer.customerCode",
            key: "customer",
            width: 150,
            ellipsis: true
        },
        {
            title: "Mã vận đơn",
            dataIndex: "billLading.ladingCode",
            key: "ladingCode",
            width: 200,
            ellipsis: true,
            scopedSlots: {customRender: "ladingCode"}
        },
        {
            title: "Bưu cục phát",
            dataIndex: "billLading.deliveryPostOffice.name",
            key: "name",
            width: 200,
            ellipsis: true,
            scopedSlots: {customRender: "deliveryPostOffice"}
        },
        {
            title: "Tuyến phát",
            dataIndex: "billLading.deliveryTargetRowGuid",
            scopedSlots: {customRender: 'deliveryTarget'},
            width: 250,
            ellipsis: true
        },
        {
            title: "Trạng thái",
            dataIndex: "status",
            key: "status",
            scopedSlots: {customRender: 'status'},
            width: 200,
            ellipsis: true
        },
        {
            title: "Người nhận",
            dataIndex: "receiver",
            key: "receiver",
            width: 150,
            ellipsis: true,
            scopedSlots: {customRender: "receiver"}
        },
        {
            title: "Ngày, giờ báo phát",
            dataIndex: "reportDeliveryDate",
            key: "reportDeliveryDate",
            scopedSlots: {customRender: "reportDeliveryDate"},
            width: 150,
            ellipsis: true
        },
        {
            title: "Ngày, giờ trạng thái",
            dataIndex: "createdDate",
            key: "createdDate1",
            width: 150,
            ellipsis: true
        }
    ]

    get reportDeliveries() {
        return ReportDeliveryStore.reportDeliveries
    }

    get pagination() {
        return {
            current: ReportDeliveryStore.meta.page,
            pageSize: ReportDeliveryStore.meta.limit,
            total: ReportDeliveryStore.meta.total,
            showTotal: (total: number) => `Tổng cộng ${total} báo phát`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }

    created() {
      ReportDeliveryStore.listReportDelivery(new ReportDeliveryParams())
    }

    onChangePage(pagination: any) {
        ReportDeliveryStore.listReportDelivery({
            ...ReportDeliveryStore.params,
            page: pagination.current,
            limit: pagination.pageSize,
            status: ReportDeliveryStatus.PHAT_THANH_CONG
        });
    }

    downloadImg(url: string, fileName: string) {
        downloadFromUrl(url, fileName);
    }
}
